import type { CartItem } from "@server/gql/graphql";
import Image from "next/image";
import Link from "next/link";
import type { ReactNode } from "react";
import type { Dictionary } from "types/common";

import { envConfig } from "@/config/env";

const ImageLink = ({
  children,
  href,
  locale,
  className,
}: {
  children: ReactNode;
  href?: string;
  locale: string | undefined;
  className?: string;
}) =>
  href ? (
    <Link className={className} prefetch={false} href={href} locale={locale}>
      {children}
    </Link>
  ) : (
    <div className={className}>{children}</div>
  );

export default function CheckoutItemFree({
  item,
  locale,
  dictionary,
}: {
  item: CartItem;
  locale?: string;
  dictionary: Dictionary;
}) {
  const { extras, brand, name, imageKey } = item;

  return (
    <div className="relative border-b border-grey-150 p-2.5 lg:px-4 lg:py-3">
      <p className="bg-black px-2.5 py-1.5 text-sm font-normal uppercase tracking-tightest text-white md:absolute md:right-2.5 md:top-2.5 md:max-w-[160px] md:px-3 md:py-2 lg:right-4 lg:top-3">
        {dictionary?.checkoutItemFreeGiftText}
      </p>
      <div className="grid h-[126px] grid-cols-[105px,_minmax(0,1fr)] items-start border-4 border-t-0 border-black md:border-t-4 lg:h-[150px] lg:grid-cols-[140px,_minmax(0,1fr)]">
        <ImageLink
          className="flex h-full max-h-[125px] w-[105px] items-stretch justify-center bg-grey-100 lg:aspect-square lg:max-h-none lg:w-full"
          href={extras?.product_url || ""}
          locale={locale}
        >
          <Image
            width={150}
            height={150}
            className="h-full w-full overflow-hidden object-contain p-5 mix-blend-multiply"
            src={`${envConfig.NEXT_PUBLIC_NORCE_IMAGE_CDN}/${imageKey}?w=200&h=200&mode=max`}
            alt={name}
          />
        </ImageLink>
        <div className="flex h-full flex-col justify-center px-4 text-base lg:gap-y-1.5 lg:px-6 lg:text-lg">
          {brand && (
            <p className="truncate text-sm uppercase lg:block">{brand}</p>
          )}
          <p className="truncate">{name}</p>
          {extras?.variant && <p className="truncate">{extras.variant}</p>}
        </div>
      </div>
    </div>
  );
}
